import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Client, Project, Supplier } from "@/v2/types";
import { TimeSheetStatus } from "@/v2/types/DraftedTimeSheet";

export interface WorkLogs {
    id: string;
    log_date: string;
    hours: number;
    status:
        | "ABSENT"
        | "SICK_LEAVE"
        | "HOLIDAY"
        | "NOT_MOBILIZED"
        | "DAY_OFF"
        | "PRESENT"
        | "RELEASED"
        | "VACATION"
        | "PUNCH_MISS"
        | "OTHER";
}

export interface TimesheetEntry {
    id: string;
    employee_name: string;
    iqama: string;
    total_hours: number;
    hourly_rate: number;
    trade: string;
    work_logs: WorkLogs[];
}

export interface TimeSheetDetails {
    id: string;
    title: string;
    description: string;
    status: TimeSheetStatus;
    note: string;
    other_deductions: number;
    deduction_note: string;
    start_date: string;
    end_date: string;
    project: Project;
    supplier: Supplier;
    client: Client;
}

export default async function FindOneTimeSheetLog({
    timeSheetId,
}: {
    timeSheetId: string;
}): Promise<{
    logs: TimesheetEntry[];
    details: TimeSheetDetails;
}> {
    const [logsRes, detailsRes] = await Promise.all([
        apiClientWithRefreshToken({
            url: `/time-sheets/logs`,
            method: "GET",
            params: {
                raw_where_condition_query: `time_sheet_logs.time_sheet_id = '${timeSheetId}'`,
            },
        }),
        apiClientWithRefreshToken({
            url: `/time-sheets/${timeSheetId}`,
            method: "GET",
        }),
    ]);

    return { logs: logsRes.data, details: detailsRes.data };
}
